export default{
    common:{
        refresh: '刷新'
    },
    menu:{
        home: '首页',
        recharge: '充值',
        withdraw: '提现',
        active: '活动',
        share: '邀请',
        task: '任务',
        income: '收入',
        game: '游戏',
        news: '我的消息',
        app:'APP下载',
        vip: 'VIP专区',
        mine: '我的',
        turnover: '账户流水',
        authorization: '授权',
        bank: '银行卡',
        error:'错误'
    },
    home:{
        recommended:'推荐'
    },
    news:{
        customer:'客服',
        notify: '通知',
        activity: '活动',
        placard: '公告',
        recommended:'推荐'
    },
    turnover:{
        type0:'存款',
        type1:'取款',
        type2:'转入',
        type3:'转出',
        type4:'投注',
        type5:'返水',
        type6:'奖金',
        today:'今日',
        week:'一周',
        halfmonth: '半个月',
        month: '一月内',
        all: '所有'
    }
}
